import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

const styles = {
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '45px',
        maxHeight: '45px',
        cursor: 'pointer',
        fontSize: '14px',
        padding: '4px 15px',
        userSelect: 'none',
        backgroundColor: COLORS.WHITE,
        borderBottom: `1px solid ${COLORS.GRAY_GALLERY}`,
    },
    menuItemLast: {
        borderBottom: '0px',
    },
    menuHover: {
        backgroundColor: COLORS.GRAY_GALLERY,
    },
};

class UploadMenuItemComponent extends Component {
    static propTypes = {
        children: PropTypes.array.isRequired,
        isLast: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        style: PropTypes.object,
    };

    state = {
        hover: false,
    };

    handleOnClick = (e) => {
        this.setState({
            hover: false,
        });

        this.props.onClick(e);
    };

    toggleHover = (isHover) => {
        this.setState({
            hover: isHover,
        });
    };

    render() {
        const { children, isLast, style } = this.props;
        const { hover } = this.state;
        const itemStyles = {
            ...styles.menuItem,
            ...style,
        };

        if (hover) {
            Object.assign(itemStyles, styles.menuHover);
        }

        if (isLast) {
            Object.assign(itemStyles, styles.menuItemLast);
        }

        return (
            <div
                style={itemStyles}
                onClick={this.handleOnClick}
                onMouseEnter={() => this.toggleHover(true)}
                onMouseLeave={() => this.toggleHover(false)}
            >
                {children}
            </div>
        );
    }
}

export default UploadMenuItemComponent;
